import s from "./platformAdmin.module.css";

export function formatRub(n) {
  return new Intl.NumberFormat("ru-RU").format(Number(n) || 0);
}

export function formatWeekLabel(isoWeek) {
  if (!isoWeek) return "";
  const d = new Date(isoWeek);
  return d.toLocaleDateString("ru-RU", { day: "numeric", month: "short" });
}

export function MetricCard({ label, value, hint, trend, accent }) {
  return (
    <article className={`${s.metricCard} ${accent ? s.metricCardAccent : ""}`}>
      <div className={s.metricLabel}>{label}</div>
      <div className={s.metricValue}>{value}</div>
      {hint ? <div className={s.metricHint}>{hint}</div> : null}
      {trend ? (
        <div
          className={`${s.metricTrend} ${
            trend === "up"
              ? s.metricTrendUp
              : trend === "down"
                ? s.metricTrendDown
                : ""
          }`}
        >
          {trend === "up" ? "↑ рост" : trend === "down" ? "↓ снижение" : "→ стабильно"}
        </div>
      ) : null}
    </article>
  );
}

export function BarChart({ title, series = [], valueSuffix = "" }) {
  const max = Math.max(...series.map((p) => p.value), 1);
  return (
    <div className={s.chartPanel}>
      {title ? <h3 className={s.panelTitle}>{title}</h3> : null}
      <div className={s.barChart}>
        {series.map((point) => (
          <div key={point.week} className={s.barCol}>
            <div className={s.barTrack}>
              <div
                className={s.barFill}
                style={{ height: `${Math.max(6, (point.value / max) * 100)}%` }}
                title={`${point.value}${valueSuffix}`}
              />
            </div>
            <span className={s.barLabel}>{formatWeekLabel(point.week)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

const INSIGHT_CLASS = {
  positive: "insightPositive",
  warning: "insightWarning",
  neutral: "insightNeutral",
};

export function InsightList({ items = [] }) {
  if (!items.length) return null;
  return (
    <div className={s.insightList}>
      {items.map((item, i) => (
        <div
          key={`${item.type}-${i}`}
          className={`${s.insightItem} ${s[INSIGHT_CLASS[item.type] || "insightNeutral"]}`}
        >
          {item.text}
        </div>
      ))}
    </div>
  );
}

export function HealthRing({ score = 0 }) {
  const pct = Math.min(100, Math.max(0, score));
  return (
    <div className={s.healthRing} style={{ "--pct": pct }}>
      <div className={s.healthRingInner}>
        <strong>{pct}</strong>
        <span>health</span>
      </div>
    </div>
  );
}

export function TopClubsTable({ title, rows = [], valueKey, valueLabel }) {
  if (!rows.length) return null;
  return (
    <div className={s.chartPanel}>
      <h3 className={s.panelTitle}>{title}</h3>
      <div className={s.topList}>
        {rows.map((row, idx) => (
          <div key={row.id} className={s.topRow}>
            <span className={s.topRank}>{idx + 1}</span>
            <div className={s.topMeta}>
              <strong>{row.name}</strong>
              <small>{row.subdomain}</small>
            </div>
            <span className={s.topValue}>
              {valueKey === "revenue_30d"
                ? `${formatRub(row[valueKey])} ₽`
                : row[valueKey]}
              {valueLabel ? ` ${valueLabel}` : ""}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
